module.exports = __webpack_public_path__ + "media/images/hdf-56bfee758db090d555d869db2d6b0bb7.jpg";